var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4595",
    "data-name": "Raggruppa 4595",
    transform: "translate(-60 -44)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2103",
    "data-name": "Rettangolo 2103",
    width: 24,
    height: 24,
    transform: "translate(60 44)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8797",
    "data-name": "Tracciato 8797",
    d: "M116.909,37.568l-3.895-3.9a.936.936,0,0,0-.667-.273h-.635a8.122,8.122,0,1,0-1.406,1.406v.636a.94.94,0,0,0,.273.667l3.9,3.895a.934.934,0,0,0,1.321,0l0,0L116.9,38.9a.944.944,0,0,0,0-1.328Zm-11.6-4.168a5,5,0,1,1,5-5,5,5,0,0,1-5,5h0Z",
    transform: "translate(-35.186 25.721)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2329ec8f1dc29f64e5460ffa6e2f9f3f.svg";
export { ForwardRef as ReactComponent };